import { ChangeEvent, useCallback, useState } from "react";

import ToggleSliderMarkup from "./markup";
import { BaseProps, LabelPositionEnum } from "./types";

export function ToggleSlider(props: BaseProps) {
	const defaultProps = {
		trueLabel: "Yes",
		falseLabel: "No",
		labelPosition: LabelPositionEnum.right,
	} as BaseProps;

	const [focused, setFocused] = useState(false);

	const updateFocused = () => setFocused(!focused);

	const onChange = useCallback(
		(event: ChangeEvent<HTMLInputElement>) => {
			if (props.disabled) return;
			if (props.changeHandler) {
				props.changeHandler(event.target.checked, props.id);
			}
		},
		[props.changeHandler, props.id, props.disabled],
	);

	return (
		<ToggleSliderMarkup
			{...defaultProps}
			{...props}
			focused={focused}
			onChange={onChange}
			updateFocused={updateFocused}
		/>
	);
}

export * from "./types";
